import React from 'react'
import styled from 'styled-components'
import { WoofMenu } from 'woof-components/src/woof-menu/WoofMenu'
import { Playground } from './Playground'

const Container = styled.div`
    display: flex;
    flex-flow: column;
    height: 100%;
`

const WoofAppContainer = styled.div`
    background: #141414 url('woof-transparent-bg.svg') no-repeat center;
    align-items: center;
    justify-content: center;
    display: flex;
    margin-top: 0rem;
    height: 100%;

    background-size: contain;

    @media screen and (min-width: 992px) {
        margin-top: 2rem;
        height: 100%;
    }
`

function App() {
    return (
        <Container>
            <WoofMenu includeWalletConnector={false} />
            <WoofAppContainer>
                <Playground />
            </WoofAppContainer>
        </Container>
    )
}

// Configure live reload
new EventSource('/esbuild').addEventListener('change', () => location.reload())

export default App
